<template>
    <div v-if="$mq === 'sm' || $mq === 'md'">
        <notifications-xs />
    </div>
    <div v-else class="notifications-outer-container-xl">
        <div class="notifications-left-side-container-xl">
            <ExpandedSidebarXl />
        </div>
        <div class="notifications-right-side-container-xl">
            <the-header-xl title="Notification" :subtitle="userNameForHeader" />
            <notfications-xl />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import baseApiAddress from '@/axios.config';
import TheHeaderXl from '@/components/header/TheHeaderXl.vue';
import ExpandedSidebarXl from '@/components/sidebar/ExpandedSidebarXl.vue';
import NotificationsXs from './components/NotificationsXs.vue';
import NotficationsXl from './components/NotficationsXl.vue';
export default {
    components: {
        TheHeaderXl,
        ExpandedSidebarXl,
        NotficationsXl,
        NotificationsXs,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['userInfo']),
        userNameForHeader() {
            return `Welcome back, ${this.userInfo.user.firstName}`;
        },
    },
    async created() {
        try {
            const { status, data } = await baseApiAddress({
                method: 'get',
                url: '/user/notification',
            });
            if (status >= 200 && status < 300) {
                this.$store.commit('notificationStore/SET_LOADING', false);
                this.$store.commit('notificationStore/SET_NOTIFICATION_DATA', data.data);
                this.$store.commit('notificationStore/SET_NOTIFICATION_ITEMS', data.data.data);
                this.$store.dispatch('notificationStore/postReadNotification');
                this.$store.dispatch('notificationStore/fetchUnreadNotificationsCount');
            }
        } catch (error) {}
    },
    beforeDestroy() {
        this.$store.commit('notificationStore/RESET_NOTIFICATION_DATA');
    },
    methods: {
        getNotificationData() {},
    },
};
</script>

<style lang="scss" scoped>
.notifications {
    &-outer-container-xl {
        height: 100vh;
        display: grid;
        grid-template-columns: 168px calc(100% - 196px);
        column-gap: 32px;
        width: 91vw;
        max-width: 1311px;
        margin: 0 auto;
    }
    &-right-side {
        &-container-xl {
            height: calc(100vh - 16px);
        }
    }
    &-left-side {
        &-container-xl {
            height: calc(100vh - 32px);
        }
    }
}
</style>
